






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { BtnList } from '@/types/common/btn'
import { AllProductListMap, ProductCfg } from '@/types/newPersion'
import {
  pensionInsuranceSummaryList,
  pensionInsuranceSave,
} from '@/api/newPersion'
import { messageBoxFn } from '@/utils/baseFn'
import { customerId } from '@/views/newPension/utils'
import TsTable from '@/components/TsTable/TsTable.vue' // @ is an alias to /src
import EmptyTable from '@/components/emptyTable/index.vue'
import NewFooter from '@/views/newPension/components/newFooter'

@Component({
  components: {
    TsTable,
    EmptyTable,
    NewFooter,
  },
})
export default class extends Vue {
  @Prop() tabInfo!: {};
  dialogShow = false;
  productCfg = (this.$attrs.proCfg as unknown) as ProductCfg;
  listPage = this.productCfg.listPage;
  btnList = this.listPage.btmBtnList;
  tableData: {
    data: {
      id: number;
      insuredName: string;
      insuranceName: string;
      children?: AllProductListMap[]
    }[]
  } = {
    data: [],
  };

  tableTitleObj = this.listPage.tableCfg.titleObjCfg;

  tableHead = this.listPage.tableCfg.tableHead;

  created () {
    this.getPensionInsuranceSummaryList()
  }

  async getPensionInsuranceSummaryList () {
    const { insuranceType, planType } = this.productCfg
    const _form = {
      customerId,
      insuranceType,
      storyLineType: planType,
    }
    const res = await pensionInsuranceSummaryList(_form)
    if (res?.data) {
      const _data = res.data
      this.tableData.data = _data
    }
  }

  /**
   *   点击下拉或者按钮按钮触发
   *    type 按钮类型
   *    tableItem 如果按钮存在表格中 tableItem就是当前项
   */
  async handleTableBtn (type: string, tableItem: AllProductListMap) {
    // console.log(
    //   '点击了表格title右侧下拉按钮，类型：',
    //   type,
    //   '按钮存在表格中显示',
    //   tableItem
    // )
    if (!tableItem) {
      this.$emit('on-click', 'setting')
    } else {
      if (type === 'del') {
        messageBoxFn(this, async (flag: boolean) => {
          if (!flag) return
          // 删除
          const res = await pensionInsuranceSave(
            { ...tableItem, deleted: true },
            'Pension'
          )
          if (res?.data) {
            this.$message({
              type: 'success',
              message: '删除成功',
            })
            this.getPensionInsuranceSummaryList()
          }
        })
      } else if (type === 'edit') {
        this.$emit('on-click', 'setting', {
          type: 'editPro',
          name: (tableItem as AllProductListMap).insuredName,
          id: (tableItem as AllProductListMap).id,
        })
      }
    }
  }

  private nextPage (item: BtnList) {
    this.$emit('on-edit-btn', item.btnType, 2)
  }
}
